import { ToastId, UseToastOptions, useToast } from "@chakra-ui/react";

export type toastFunction = (
  message: string,
  options?: UseToastOptions,
) => ToastId;

type useAppToastReturnType = {
  error: toastFunction;
  info: toastFunction;
  warn: toastFunction;
  success: toastFunction;
  toast: {
    (options?: UseToastOptions | undefined): ToastId;
    update(id: ToastId, options: Omit<UseToastOptions, "id">): void;
    close: (id: ToastId) => void;
    isActive: (id: ToastId) => boolean;
  };
};

export function useAppToast(): useAppToastReturnType {
  const toast = useToast({
    containerStyle: {
      zIndex: 9999,
    },
  });

  return {
    error: (message: string, options?: UseToastOptions) =>
      toast({
        title: "Error",
        ...options,
        status: "error",
        description: message,
      }),
    warn: (message: string, options?: UseToastOptions) =>
      toast({
        title: "Warning",
        ...options,
        status: "warning",
        description: message,
      }),

    info: (message: string, options?: UseToastOptions) =>
      toast({
        title: "Info",
        ...options,
        status: "info",
        description: message,
      }),

    success: (message: string, options?: UseToastOptions) =>
      toast({
        ...options,
        status: "success",
        description: message,
      }),
    toast,
  };
}
